<template>
  <div class="details_view">
    <el-dialog
      title="考生详情"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="75%"
    >
      <el-table
        ref="tabledata"
        :data="getData"
        style="width: 100%"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <!-- <el-table-column
              type="selection"
              width="80"
              :reserve-selection="true"
            ></el-table-column> -->
        <!-- <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage3 - 1) * pageSize }}
          </template>
        </el-table-column> -->
        <el-table-column
          v-for="(item, index) in $parent.$parent.courseware !== 'courseware'
            ? formColumns
            : formColumnsTwo"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="newWatchTime"
          label="本次学习时长"
          v-if="$parent.$parent.courseware !== 'courseware'"
        >
        </el-table-column>
        <el-table-column
          label="本次学习时长"
          v-else-if="$parent.$parent.courseware == 'courseware'"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.duration }}</div>
          </template>
        </el-table-column>
      </el-table>

      <div class="foot_box">
        <div class="foot_pagetions">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageIndex"
            :page-size="eachPageNum"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import resourcereq from "@/api/resources";
export default {
  data() {
    return {
      dialogVisible: false,
      diatil: {}, //用户详情数据
      pageIndex: 1, // 起始页
      eachPageNum: 5, // 一共多少条
      total: 100,
      pagesizesarr: [5, 10, 20, 50, 100],
      getData: [],
      formColumns: [
        {
          prop: "RealName",
          label: "考生姓名",
          // width: "90px",
        },
        {
          prop: "UserName",
          label: "考生账号",
          // width: "90px",
        },
        {
          prop: "Telephone",
          label: "手机号",
          // width: "90px",
        },
        {
          prop: "DepartmentName",
          label: "科室",
          //   width: "100px",
        },
        {
          prop: "PTitle",
          label: "职称",
          // width: "90px",
        },
        {
          prop: "isComplete",
          label: "是否达到有效学习时长",
          width: "160px",
        },
        {
          prop: "videoTime",
          label: "视频时长",
          //  width: "80px",
        },
        {
          prop: "startTime",
          label: "最近进入时间",
          width: "160px",
        },
        {
          prop: "endTime",
          label: "最近离开时间",
          width: "160px",
        },
        // {
        //   prop: "userCount",
        //   label: "点击次数",
        //   //  width: "80px",
        // },
        // {
        //   prop: "progorecc",
        //   label: "学习进度",
        //   //  width: "80px",
        // },
        // {
        //   prop: "watchTime",
        //   // prop:'duration',
        //   label: "本次学习时长",
        //   //  width: "80px",
        // },
      ],
      formColumnsTwo: [
        {
          prop: "RealName",
          label: "考生姓名",
          // width: "90px",
        },
        {
          prop: "UserName",
          label: "考生账号",
          // width: "90px",
        },
        {
          prop: "Telephone",
          label: "手机号",
          // width: "90px",
        },
        {
          prop: "DepartmentName",
          label: "科室",
          //   width: "100px",
        },
        {
          prop: "PTitle",
          label: "职称",
          // width: "90px",
        },
        {
          prop: "startTime",
          label: "最近进入时间",
          width: "160px",
        },
        {
          prop: "endTime",
          label: "最近离开时间",
          width: "160px",
        },
      ],
    };
  },
  props: ["diatilobj"],
  methods: {
    // 百分比计算
    toPercent(num, total) {
      // num 传实际数占total的数值 total 传百分百 toFixed(2)
      return Math.round((num / total) * 10000) / 100.0 + "%";
    },
    getTableData() {
      let pamars = {
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        studentUserID: this.diatilobj.studentId,
        // pageIndex: this.pageIndex == 0 ? 0 : this.pageIndex - 1,
        pageIndex: this.pageIndex - 1,
        pageShow: this.eachPageNum,
        courseID: "",
        videoID: "",
      };
      if (this.$parent.$parent.courseware == "courseware") {
        pamars.courseID = this.diatilobj.courseID;
        resourcereq.courseDetailById(pamars).then((res) => {
          res.data.Data[0].forEach((item) => {
            item.endTime = this.$moment(item.endTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            item.startTime = this.$moment(item.startTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            if (item.watchTime) {
              item.watchTime1 = item.watchTime.split("页")[0];
            }
            if (item.videoTime) {
              item.videoTime = item.videoTime.split("页")[0];
            }
            item["progorecc"] = this.toPercent(
              item.watchTime1,
              item.videoTime1
            );
            // 计算学习时长 最后时间减开始时间
            item.duration =
              Number(this.$moment(item.endTime).format("X")) -
              Number(this.$moment(item.startTime).format("X"));
            item.duration = this.timeFormat(item.duration);
            item.watchTime1 / item.videoTime1 + "%";
            for (let ztiem in item) {
              if (item[ztiem] === "" || item[ztiem] === null) {
                item[ztiem] = "未设置";
              }
            }
          });
          this.getData = res.data.Data[0];
          this.total = res.data.Data[1][0].dataCount;
        });
      } else {
        pamars.videoID = this.diatilobj.videoId;
        resourcereq.videoDetailById(pamars).then((res) => {
          res.data.Data[0].forEach((item) => {
            // 前端计算 startTime - endTime
            // item.sTime = new Date(item.startTime).getTime()
            // item.eTime = new Date(item.endTime).getTime()
            item.sTime = this.$moment(item.startTime).valueOf();
            item.eTime = this.$moment(item.endTime).valueOf();
            item.videoTime =
              item.videoTime === "null秒" ? "无" : item.videoTime;
            item.watchTime =
              item.watchTime === "null秒" ? "无" : item.watchTime;
            const time = Number(item.eTime) - Number(item.sTime);
            if (time <= 0) {
              // 取后端数据
              item.newWatchTime = item.watchTime;
            } else {
              var duration = this.$moment.duration(time);
              var hours = duration.hours(); // 小时数
              var minutes = duration.minutes(); // 分钟数
              var seconds = duration.seconds(); // 秒数
              item.newWatchTime =
                item.watchTime === "无"
                  ? "无"
                  : hours + "时" + minutes + "分" + seconds + "秒";
            }
            item.endTime = item.endTime
              ? this.$moment(item.endTime).format("YYYY-MM-DD HH:mm:ss")
              : "无数据";
            item.startTime = item.startTime
              ? this.$moment(item.startTime).format("YYYY-MM-DD HH:mm:ss")
              : "无数据";
            if (item.watchTime) {
              item.watchTime1 = item.watchTime.split("秒")[0];
            }
            if (item.videoTime) {
              item.videoTime1 = item.videoTime.split("秒")[0];
            }
            item["progorecc"] = item.watchTime1
              ? this.toPercent(item.watchTime1, item.videoTime1)
              : "0";
            if (item["progorecc"] == "NaN%") {
              item["progorecc"] = "0%";
            }
          });
          this.getData = res.data.Data[0];
          console.log(this.getData);

          this.total = res.data.Data[1][0].dataCount;
        });
      }
    },
    // 分页
    handleSizeChange(val) {
      this.eachPageNum = val;

      this.isLoading = true;
      this.getTableData(); // 重新发起请求
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.isLoading = true;
      this.getTableData(); // 重新发起请求
    },
    /** 传入的是秒， */
    timeFormat(second) {
      return this.$moment.utc(second * 1000).format("HH:mm:ss秒");
    },
  },
  watch: {
    dialogVisible(newName) {
      if (newName) {
        this.getTableData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.details_view {
  ::v-deep .el-dialog__header {
    height: 56px;
    line-height: 56px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    padding: 0px 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog__footer {
    padding: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 56px;
    span > button {
      width: 96px;
      height: 40px;
      opacity: 1;
      border-radius: 4px;
      padding: 0px;
      margin-bottom: 22px;
    }
    span > button:nth-child(1) {
      background: #ffffffff;
      color: #999999;
      border: 1px solid #dddddd;
    }
    span > button:nth-child(2) {
      background: #1890ff;
      border: 1px solid #1890ff;
      color: #ffffffff;
      margin-left: 50px;
    }
  }
}

.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
</style>
